( function( $ ) {

    // Set videos ratio
    var GDPR = {
        Init: function () {
            $( 'body' ).append(
                '<div class="gdpr-banner" id="gdpr-banner">' +
                    '<div class="gdpr-content fs-text-tiny">' +
                        '<p>' + script_vars.gdpr_content + '</p>' +
                        '<button class="btn btn-size-small btn-color-blue" id="gdpr-approve">' + script_vars.gdpr_button + '</button>' +
                    '</div>' +
                '</div>'
            );
        },

        Accepted: function () {
            $( '#gdpr-banner' ).addClass('removed');

            setTimeout( function() {
                $( '#gdpr-banner' ).remove();
            }, 300 );

            var date = new Date();
            date.setFullYear(date.getFullYear() + 1 );
            VCUtils.SetCookie( 'vc_cookie_accepted' , 'true', '/', date, window.location.hostname.replace('www.', '') );
        }
    };

    $(document).ready( function() {
        if ( !VCUtils.GetCookie( 'vc_cookie_accepted' ) ) {
            GDPR.Init();

            $( 'body' ).on( 'click', '#gdpr-approve', GDPR.Accepted );
        }
    } );

})(jQuery);
